import * as yup from 'yup'

const schema = {
  comment: yup.string(),
}

export const commentValidationSchema = yup.object().shape(schema)
